const SIGNOUT_LOCAL_STORAGE_STAY_KEYS = new Set<string>(['theme']);
const COGNITO_STORAGE_PREFIX = 'CognitoIdentityServiceProvider.';

// Cognito key suffixes that hold the active session. Removing these forces a
// re-login but leaves the device-trust record (deviceKey/deviceGroupKey/
// randomPasswordKey) untouched so MFA-on-trusted-device still works.
const COGNITO_SESSION_KEY_SUFFIXES = [
  '.accessToken',
  '.idToken',
  '.refreshToken',
  '.clockDrift',
  '.userData',
  '.signInDetails',
];

// Suffixes that record the 30-day Cognito "remember device" trust. These must
// survive an explicit signOut, otherwise the user is re-prompted for MFA on
// next login despite having opted into device trust.
const COGNITO_DEVICE_TRUST_KEY_SUFFIXES = [
  '.deviceKey',
  '.deviceGroupKey',
  '.randomPasswordKey',
];

const isCognitoDeviceTrustKey = (key: string) =>
  key.startsWith(COGNITO_STORAGE_PREFIX) &&
  COGNITO_DEVICE_TRUST_KEY_SUFFIXES.some(suffix => key.endsWith(suffix));

export const hasPersistedAuthSession = () => {
  try {
    return Object.keys(localStorage).some(
      key =>
        key.startsWith(COGNITO_STORAGE_PREFIX) &&
        (key.endsWith('.accessToken') ||
          key.endsWith('.idToken') ||
          key.endsWith('.refreshToken') ||
          key.endsWith('.LastAuthUser')),
    );
  } catch {
    return false;
  }
};

export const clearAuthStorage = () => {
  try {
    Object.keys(localStorage)
      .filter(
        key =>
          !SIGNOUT_LOCAL_STORAGE_STAY_KEYS.has(key) &&
          !isCognitoDeviceTrustKey(key),
      )
      .forEach(key => localStorage.removeItem(key));
  } catch {
    // localStorage may be inaccessible (private mode, disabled storage)
  }
  try {
    sessionStorage.clear();
  } catch {
    // sessionStorage may be inaccessible
  }
};

// Used by the browser-close detection path. Unlike clearAuthStorage (explicit
// signout), this preserves the Cognito device-trust keys so a remembered
// device still skips MFA on next login.
export const clearAuthSessionTokens = () => {
  try {
    Object.keys(localStorage)
      .filter(
        key =>
          key.startsWith(COGNITO_STORAGE_PREFIX) &&
          COGNITO_SESSION_KEY_SUFFIXES.some(suffix => key.endsWith(suffix)),
      )
      .forEach(key => localStorage.removeItem(key));
  } catch {
    // localStorage may be inaccessible
  }
  try {
    sessionStorage.clear();
  } catch {
    // sessionStorage may be inaccessible
  }
};
